<template>
  <nuttrema-layout-content-header class='is-height-inherit'>
    <template slot="left">
      <div class="content-header-item">
        <nuttrema-group-and-sort>
          <h4 slot="label">{{ $t('label.measurements') }}</h4>
          <el-button-group slot="content">
            <el-button
               size="small"
              :class="{ 'is-active': activeView === 'page-evolution-measurements-list' }"
              @click="changeActiveView('page-evolution-measurements-list')">
              {{ $t('label.list') }}
            </el-button>
            <el-button
               size="small"
              :class="{ 'is-active': activeView === 'page-evolution-measurements-graph' }"
              @click="changeActiveView('page-evolution-measurements-graph')">
              {{ $t('label.graph') }}
            </el-button>
          </el-button-group>
        </nuttrema-group-and-sort>
      </div>
      <div class="content-header-item">
        <nuttrema-group-and-sort>
          <h4 slot="label">{{ $t('label.period') }}</h4>
          <el-select
             slot="content"
             v-model="timePeriod"
             size="small"
            @change="changeTimePeriod">
            <el-option :label="$t('label.this_week')" :value="calendar.timePeriod.thisWeek"></el-option>
            <el-option :label="$t('label.this_month')" :value="calendar.timePeriod.thisMonth"></el-option>
            <el-option :label="$t('label.previous_month')" :value="calendar.timePeriod.previousMonth"></el-option>
            <el-option :label="$t('label.custom')" :value="calendar.timePeriod.custom"></el-option>
          </el-select>
        </nuttrema-group-and-sort>
      </div>
      <div class="content-header-item">
        <nuttrema-group-and-sort v-if="timePeriod === calendar.timePeriod.custom">
          <h4 slot="label">{{ $t('label.custom_period', { value: 3 }) }}</h4>
          <el-date-picker
             slot="content"
             v-model="selectedPeriod"
             type="daterange"
             size="small"
             format="dd/MM/yyyy"
             value-format="yyyy-MM-dd"
             align="center"
            :placeholder="$t('label.pick_a_range')"
            :style="{ width: '18em' }"
            :editable="false"
            :clearable="false"
            :unlink-panels="false"
            :picker-options="{ firstDayOfWeek: 1, onPick: handleOnPick, disabledDate }"
            @input="changeTimePeriodCustom">
          </el-date-picker>
        </nuttrema-group-and-sort>
      </div>
    </template>
    <!-- end ~ left -->
    <div class="content-header-item" slot="right" v-show="selectedPeriod">
      <nuttrema-group-and-sort class="is-right-aligned">
        <h4 slot="label" class="no-padding">{{ $t('label.selected_period') }}</h4>
        <h4 slot="content" class="content--title">
          <template v-if="_get(selectedPeriod, '0') && _get(selectedPeriod, '1')">
            {{ selectedPeriod[0] | moment('ll') }} - {{ selectedPeriod[1] | moment('ll') }}
          </template>
        </h4>
      </nuttrema-group-and-sort>
    </div>
    <!-- end ~ right -->
  </nuttrema-layout-content-header>

</template>

<script>
import moment from 'moment';
import * as calendar from 'utils/calendar';
import { cloneDeep, omitBy, isNil, get } from 'lodash';

import NuttremaLayoutContentHeader from 'components/ui/layout/nuttrema-layout-content-header';
import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';

export default {
  name: 'cmpt-measurements-select-time-period',
  props: {
    period: {
      type: String,
      required: true,
      default: null,
    },
    dateFrom: {
      required: false,
      default: null,
    },
    dateTo: {
      required: false,
      default: null,
    },
    sections: {
      type: Array,
      required: false,
      default: null,
    },
    trackable: {
      type: Object,
      required: false,
      default: null,
    },
    activeChart: {
      type: String,
      required: false,
      default: null,
    },
    activeView: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLayoutContentHeader,
    NuttremaGroupAndSort,
  },
  data() {
    return {
      calendar,
      timePeriod: this.period,
      selectedPeriodFrom: null,
      selectedPeriodTo: null,
      selectedChart: this.activeChart,
      selectedPeriod: calendar.getPeriod(this.period, this.dateFrom, this.dateTo),
      selectedCopy: calendar.getPeriod(this.period, this.dateFrom, this.dateTo),
    };
  },
  methods: {
    disabledDate(date) {
      // const min = date.getTime() < moment(this.selectedPeriodFrom).subtract(3, 'month').add(1, 'day').toDate();
      // const max = date.getTime() > moment(this.selectedPeriodFrom).add(3, 'month').subtract(1, 'day').toDate();
      const future = date.getTime() > moment().toDate();
      return future;
    },
    changeTimePeriod(timePeriod) {
      if (timePeriod !== calendar.timePeriod.custom) {
        this.timePeriod = timePeriod;
        this.selectedCopy = calendar.getPeriod(timePeriod);
        this.selectedPeriod = calendar.getPeriod(timePeriod);
        this.selectedPeriodFrom = null;
        this.selectedPeriodTo = null;
        this.$emit('changeTimePeriod', {
          period: this.timePeriod,
          dateFrom: this.selectedPeriod[0],
          dateTo: this.selectedPeriod[1],
        });
      }
    },
    changeTimePeriodCustom(date) {
      const changed = this.selectedCopy[0].valueOf() !== get(date, '0', '').valueOf() || this.selectedCopy[1].valueOf() !== get(date, '1', '').valueOf();
      if (changed) {
        this.timePeriod = calendar.timePeriod.custom;
        this.selectedCopy = cloneDeep(this.selectedPeriod);
        this.selectedPeriodFrom = null;
        this.selectedPeriodTo = null;
        this.$emit('changeTimePeriod', {
          period: this.timePeriod,
          dateFrom: this.selectedPeriod[0],
          dateTo: this.selectedPeriod[1],
        });
      }
    },
    changeSelectedChart(value) {
      this.$emit('update:activeChart', value);
    },
    changeActiveView(value) {
      this.$emit('update:activeView', value);
    },
    handleOnPick(values) {
      this.selectedPeriodFrom = get(values, 'minDate');
      this.selectedPeriodTo = get(values, 'maxDate');
    },
  },
  computed: {
    query() {
      const query = {
        period: this.period,
        date_from: this.dateFrom,
        date_to: this.dateTo,
      };
      return omitBy(query, isNil);
    },
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/dashboard/cmpt-measurements-select-time-period.vue